<template>
  <div>
    <a-dropdown v-if="!disabled" :trigger="['click']">
      <span class="edit-status">
        <a-tag :color="reviewStatus[status].color">{{ reviewStatus[status].label }}</a-tag>
        <a-icon class="icon-down" type="down" />
      </span>
      <a-menu slot="overlay">
        <a-menu-item v-for="(item, index) in nextStatus" :key="index" @click="onChange(item.node_id)">
          <a-tag :color="reviewStatus[item.node_id].color">{{ reviewStatus[item.node_id].label }}</a-tag>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <a-badge v-else :status="reviewStatus[status].status" :text="reviewStatus[status].label" />
  </div>
</template>

<script>
import { reviewStatus } from '@/utils/dictionary';
import { reviewUpdateStatus } from '@/api/project/review';

export default {
  name: 'TestPlanStatusEdit',
  props: {
    status: {
      type: [String, Number],
      default: null
    },
    nextStatus: {
      type: Array,
      default: () => {
        return [];
      }
    },
    reviewId: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      reviewStatus,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  methods: {
    onChange(value) {
      reviewUpdateStatus({ review_id: this.reviewId, status: value }).then(() => {
        this.$message.success('状态更新成功');
        this.$emit('change');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-status {
  cursor: pointer;
  display: inline-block;
  padding: 0 4px;
  line-height: 22px;

  .icon-down {
    opacity: 0;
  }
}

.edit-status:hover {
  cursor: pointer;
  background-color: #e4e4e4;

  .icon-down {
    opacity: 1;
  }
}
</style>
